var small = {
  imageWidthDesktopBase: 21,
  imageWidthMobileBase: 21,
  imageWidthDesktopBaseGlobe: 18,
  imageWidthMobileBaseGlobe: 18,
  imageHeightAndWidthDiff: 3,
  plusSignFontSize: 19
};
var medium = {
  imageWidthDesktopBase: 30,
  imageWidthMobileBase: 27,
  imageWidthDesktopBaseGlobe: 27,
  imageWidthMobileBaseGlobe: 21,
  imageHeightAndWidthDiff: 4,
  plusSignFontSize: 25
};

export { medium as mediumConstants, small as smallConstants };
//# sourceMappingURL=styleConstantsBySize.js.map
